// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import toast from 'react-hot-toast'

// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('appUsers/getAllData', async (params) => {
  const response = await axios.post('https://api.fntpf.ir/admin/getallghate', { account_type: params})
  return response.data
})

export const getSingle = createAsyncThunk('appUsers/getSingle', async id => {
  const response = await axios.post('https://api.fntpf.ir/partsReq/admin/getSingleRequest', { id })
  if (response.data.status) return response.data
})

export const getClientInfo = createAsyncThunk('appUsers/getClientInfo', async (params) => {
  const response = await axios.post('https://api.fntpf.ir/get/ClientInfo', { id: params})
  if (response.data.status) return response.data.client
})


export const getAllClients = createAsyncThunk('appUsers/getAllClients', async (params) => {
  const response = await axios.post('https://api.fntpf.ir/getclients', { account_type: params})
  return response.data
})

export const getTaskData = createAsyncThunk('appUsers/getTaskData', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/gettask', params)
  return response.data.tasks
})

export const getTaskData2 = createAsyncThunk('appUsers/getTaskData2', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/gettask', params)
  return response.data.tasks
})

export const getDataCount = createAsyncThunk('appUsers/getDataCount', async (params) => {
  const response = await axios.post('https://api.fntpf.ir/admin/getallghateCount', { account_type: params})
  if (response.data.status) return response.data.results
})

export const addNews = createAsyncThunk('appUsers/addNews', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/addnews', params)
  if (response.data.status) {
    toast.success(response.data.message)
    return response.data
  } else toast.error(response.data.message)
})

export const getData = createAsyncThunk('appUsers/getData', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getallghate', params)
  console.log(response.data.count)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.count
  }
})

export const getPayment = createAsyncThunk('appUsers/getPayment', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/user/payments', params)
  return response.data
})
export const getFilteredPayment = createAsyncThunk('appUsers/getFilteredPayment', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/user/filteredpayments', params)
  console.log(response.data)
  return response.data
})

export const getClients = createAsyncThunk('appUsers/getClients', async params => {
  const response = await axios.post('https://api.fntpf.ir/getclients', params)
  console.log(response.data.count)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.count
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.post('https://api.fntpf.ir/admin/getUser', { id })
  return response.data.user
})

export const getAllAgents = createAsyncThunk('appUsers/getAllAgents', async () => {
  const response = await axios.post('https://api.fntpf.ir/admin/getagentsV3forGhate', { id:1 })
  if (response.data.status) return response.data.users
})
export const getRequest = createAsyncThunk('appUsers/getRequest', async id => {
  const response = await axios.post('https://api.fntpf.ir/admin/getUser', { id })
  return response.data.user
})

export const editUser = createAsyncThunk('appUsers/editUser', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/updateagentprofile', params)
  if (response.data.status) {
    toast.success(response.data.message)
    return response.data
  } else toast.error(response.data.message)
})

export const editClient = createAsyncThunk('appUsers/editClient', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/updateclientprofile', params)
  if (response.data.status) {
    toast.success(response.data.message)
    return response.data
  } else toast.error(response.data.message)
})

export const getNews = createAsyncThunk('appUsers/getNews', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getAgentNews', params)
  return response.data.news
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  console.log("USER Not ADDED!", user)
  const response = await axios.post('https://api.fntpf.ir/addagent', user)
  console.log("USER ADDED!", response)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  if (response.data.status) {
    toast.success(response.data.message)
  } else toast.error(response.data.error)
  return user
})

export const addClient = createAsyncThunk('appUsers/addClient', async (user, { dispatch, getState }) => {
  console.log("USER Not ADDED!", user)
  const response = await axios.post('https://api.fntpf.ir/addclient', user)
  console.log("USER ADDED!", response)
  await dispatch(getClients(getState().users.params))
  await dispatch(getAllClients())
  if (response.data.status) {
    toast.success(response.data.message)
  } else toast.error(response.data.error)
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    tasks: [],
    subsetTasks: [],
    dataCount:[],
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    editStatus: {},
    addNewsStatus: null,
    newsHistory: null,
    payments: [],
    allPayments: [],
    allAgents: [],
    singleReq: {},
    partLog: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getSingle.fulfilled, (state, action) => {
        state.singleReq = action.payload.request
        state.partLog = action.payload.requestLog
      })
      .addCase(getAllClients.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getTaskData.fulfilled, (state, action) => {
        state.tasks = action.payload
      })
      .addCase(getTaskData2.fulfilled, (state, action) => {
        state.subsetTasks = action.payload
      })
      .addCase(getDataCount.fulfilled, (state, action) => {
        state.dataCount = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      }).addCase(getClients.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.editStatus = action.payload
      }).addCase(editClient.fulfilled, (state, action) => {
          state.editStatus = action.payload
      }).addCase(getNews.fulfilled, (state, action) => {
        state.newsHistory = action.payload
      }).addCase(addNews.fulfilled, (state, action) => {
        state.addNewsStatus = action.payload
      }).addCase(getPayment.fulfilled, (state, action) => {
        state.payments = action.payload.data
        state.allPayments = action.payload.allData
      }).addCase(getFilteredPayment.fulfilled, (state, action) => {
        state.payments = action.payload.data
        state.allPayments = action.payload.allData
      }).addCase(getClientInfo.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      }).addCase(getAllAgents.fulfilled, (state, action) => {
        state.allAgents = action.payload
      })
  }
})

export default appUsersSlice.reducer
